// 메신저(Mattermost) iframe 에 주입하는 모달 CSS — 모바일에서 모달 헤더와 본문을 한 면으로 이어 붙인다. · (2026-09-29) 모바일 헤더 햄버거 :focus 배경 보정(⑤)도 여기 둔다.
// 왜 CSS 주입인가: 메신저는 외부 앱(컨테이너 이미지)이라 마크업을 고칠 수 없고, 같은 오리진 iframe 이라
// 우리가 통제할 수 있는 지점은 그 문서에 넣는 style 요소뿐이다(EmbedPage injectHideCss 선례 = CSP 무관).
// 🔴 전 규칙을 @media (max-width:768px) 안에 둔다 — 데스크톱 회귀 0(mmModalCss.test.js 가 단언).
//    모바일은 MobileScale zoom 때문에 iframe 내부 CSS 폭이 ~375px 라 이 구간에 들어오고,
//    데스크톱·데스크톱 창의 수동 '모바일 전환'(~911px)은 들어오지 않는다.
// 🔴 overflow:hidden 금지 — 모달 안에서 열리는 MM 드롭다운·툴팁이 잘린다. 모서리는 헤더·본문을
//    투명 + border-radius:0 으로 만들어 .modal-content 의 radius 만 보이게 해 처리한다.
// 🔴 헤더 position 은 relative(static 금지) — 헤더 안 절대배치 닫기(×) 버튼의 기준이 사라지면 튄다.
// MM 모달은 react-bootstrap(.modal-dialog .modal-content .modal-header/.modal-body) 구조가 공통이고
// 신형(GenericModal)은 그 위에 GenericModal__header/__body 를 겹쳐 붙인다 → 두 계열을 모두 나열한다.
// 🔴 헤더·본문 규칙에 직계 자식 결합자(>)를 쓰지 않는다 — 2026-09-28 DEV 실측에서 MM 9.8 GenericModal 은
//    .modal-content > div.GenericModal__wrapper > (header, body) 로 한 겹 더 감싼다
//    (childClasses=['GenericModal__wrapper GenericModal__wrapper-enter-key-press-catcher']).
//    직계로 쓴 앞 버전은 헤더·본문 규칙이 하나도 안 먹었다(실측 headerPosition='static', 하위 결합자인
//    ①만 먹어 contentBg 만 흰색) → 하위(descendant) 결합자로 쓰고, 래퍼 자신은 ④로 눌러 둔다.
export const MM_MODAL_STYLE_ID = 'gw-mm-modal-css';

export const MM_MODAL_CSS = [
  '@media (max-width:768px){',
  // ① 모달 전체를 한 장의 면으로
  '.modal-dialog .modal-content{background:#fff !important;border:0 !important;border-radius:10px !important;box-shadow:0 10px 40px rgba(0,0,0,.24) !important}',
  // ② 헤더는 자기 배경·테두리·그림자를 그리지 않는다(절대배치 해제는 relative 까지만)
  '.modal-dialog .modal-content .modal-header,.modal-dialog .modal-content [class*="GenericModal__header"]{position:relative !important;margin:0 !important;padding:16px 16px 8px !important;background:transparent !important;border:0 !important;border-radius:0 !important;box-shadow:none !important;min-height:0 !important}',
  // ③ 본문이 헤더 바로 아래 붙는다 — 상단 여백만 0(좌·우·하단은 MM 값 유지)
  '.modal-dialog .modal-content .modal-body,.modal-dialog .modal-content [class*="GenericModal__body"]{margin:0 !important;padding-top:0 !important;background:transparent !important;border:0 !important;border-radius:0 !important;box-shadow:none !important}',
  // ④ 헤더·본문을 감싸는 중간 래퍼(GenericModal__wrapper)도 자기 면·여백을 그리지 않는다
  '.modal-dialog .modal-content > [class*="GenericModal__wrapper"]{background:transparent !important;border:0 !important;padding:0 !important;margin:0 !important;border-radius:0 !important;box-shadow:none !important}',
  // ⑤ 헤더 왼쪽 햄버거(≡)의 :focus 배경 제거 — MM 은 :hover 만 투명으로 되돌리고 :focus 는 안 덮어
  //    부트스트랩 `.navbar-default .navbar-toggle:focus{background-color:#ddd}` 가 남는다(탭 뒤 연회색 사각형).
  //    오른쪽 아이콘(.navbar-right__icon)은 MM 이 :focus 까지 덮으므로 건드리지 않는다(2026-09-29 DEV MM 11.11.0 CSS 실측).
  //    음소거 채널 종 아이콘(navbar-toggle icon icon__mute)에도 걸린다 — MM 의 :hover 투명 규칙과 같은 범위라 일관된다.
  '#navbar_wrapper .navbar-default .navbar-toggle:not(.navbar-right__icon):focus{background:transparent !important}',
  '}',
].join('');

// style#gw-mm-modal-css 를 head 에 '1개만' 유지한다. 폴링 루프(50ms×120)+onLoad 에서 반복 호출되므로
// 멱등이 필수 — 이미 있으면 새로 만들지 않고 내용이 달라졌을 때만 갱신한다.
// doc·head 가 없으면(로드 중 문서) 조용히 no-op — injectHideCss 와 같은 형태.
export function applyMmModalCss(doc) {
  if (!doc || !doc.head) return;
  const found = doc.getElementById(MM_MODAL_STYLE_ID);
  if (found) {
    if (found.textContent !== MM_MODAL_CSS) found.textContent = MM_MODAL_CSS;
    return;
  }
  const st = doc.createElement('style');
  st.id = MM_MODAL_STYLE_ID;
  st.textContent = MM_MODAL_CSS;
  doc.head.appendChild(st);
}
